import {IPluginHooks} from '../ToolbarPlugin/types';
import {INSERT_HORIZONTAL_RULE_COMMAND} from '@lexical/react/LexicalHorizontalRuleNode';
import {createDispatchCommandWithoutPayload} from '../ToolbarPlugin/utils';

export const useCustomDividerCommand = ({editor}: IPluginHooks) => {
    const dispatchCommand = createDispatchCommandWithoutPayload(editor);

    const handleDividerInsert = () => {
        dispatchCommand(INSERT_HORIZONTAL_RULE_COMMAND);
    };

    return {handleDividerInsert} as const;
};
